var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "g6",
  clipPath: "url(#clip0_259_10475)",
  transform: "matrix(.94 0 0 .94 0 -.47)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path2",
  fill: "url(#paint0_linear_259_10475)",
  d: "M8.5 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
  style: {
    fill: "url(#paint0_linear_259_10475)"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "path4",
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.85 8.91c2.48-1.08 4.13-1.8 4.95-2.13 2.36-.99 2.86-1.16 3.18-1.16.07 0 .22.01.32.1.1.07.11.16.13.23 0 .06.02.21.01.33-.13 1.34-.68 4.6-.96 6.11-.12.64-.36.85-.58.87-.5.05-.87-.32-1.35-.64-.75-.49-1.17-.8-1.9-1.27-.84-.55-.3-.86.19-1.35.12-.13 2.3-2.11 2.34-2.3 0-.01 0-.1-.04-.14-.05-.05-.13-.03-.18-.02-.07.02-1.27.8-3.58 2.37-.34.23-.65.35-.93.34-.3 0-.88-.17-1.32-.31-.53-.17-.95-.27-.91-.56.01-.15.23-.31.63-.47",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "defs16"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_259_10475",
  x1: 850,
  x2: 850,
  y1: 0.5,
  y2: 1687.89,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop8",
  stopColor: "#2AABEE"
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop10",
  offset: 1,
  stopColor: "#229ED9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_259_10475"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect13",
  fill: "#fff",
  d: "M0 0h17v17H0z",
  transform: "translate(0 .5)"
})))));
export default SvgTelegram;